<template>
  <div class="multi-select">
    <!-- Добавить элемент -->
    <b-button size="sm" variant="primary" class="mb-2" @click="showSelector = true">
      Добавить элемент
    </b-button>

    <!-- Селектор с поиском -->
    <b-form-input
      v-if="showSelector"
      v-model="search"
      placeholder="Поиск..."
      size="sm"
      class="mb-2"
    />

    <b-form-select
      v-if="showSelector"
      v-model="tempValue"
      :options="filteredOptions"
      :placeholder="searchPlaceholder"
      size="sm"
      class="mb-2"
      @change="addSelected"
    />

    <!-- Список выбранных элементов -->
    <div class="selected-list d-flex flex-wrap">
      <b-badge
        v-for="item in selectedItems"
        :key="item[valueField]"
        variant="light"
        class="mr-1 mb-1 d-flex align-items-center"
      >
        {{ item[textField] }}
        <b-btn size="sm" variant="light" class="ml-1 p-0" @click="removeItem(item)">
          <font-awesome-icon icon="fa-times"></font-awesome-icon>
        </b-btn>
      </b-badge>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleMultiSelect",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
    },
    textField: {
      type: String,
      default: "text",
    },
    valueField: {
      type: String,
      default: "value",
    },
    searchPlaceholder: {
      type: String,
      default: "Поиск...",
    },
  },

  data() {
    return {
      search: "",
      tempValue: null,
      showSelector: false,
      selectedItems: [...this.value],
    };
  },

  computed: {
    filteredOptions() {
      const term = this.search.trim().toLowerCase();
      return this.items
        .filter(
          (i) =>
            !this.selectedItems.some((sel) => sel[this.valueField] === i[this.valueField])
        )
        .filter((i) => !term || String(i[this.textField]).toLowerCase().includes(term))
        .map((i) => ({ text: i[this.textField], value: i[this.valueField] }));
    },
  },

  watch: {
    value(val) {
      this.selectedItems = [...val];
    },
  },

  methods: {
    addSelected() {
      if (!this.tempValue) return;
      const item = this.items.find((i) => i[this.valueField] === this.tempValue);
      if (item) {
        this.selectedItems.push(item);
      }
      this.tempValue = null;
      this.search = "";
      this.$emit("input", this.selectedItems);
      // this.showSelector = false; // убираем
    },

    removeItem(item) {
      this.selectedItems = this.selectedItems.filter(
        (i) => i[this.valueField] !== item[this.valueField]
      );
      this.$emit("input", this.selectedItems);
    },
  },
};
</script>

<style scoped>
.selected-list b-badge {
  display: inline-flex;
  align-items: center;
}
</style>
